import { render } from 'react-dom'
import { SidebarCars } from '../../Posts/SidebarCars'

document.addEventListener('DOMContentLoaded', () => {
  render(<SidebarCars />, document.getElementById('sidebar-cars'))
})
